import axios from "axios";
import CONFIG from "../config";
import { attachAuthInterceptor } from "./authInterceptor";

const reportsApi = axios.create({
  baseURL: CONFIG.REPORTS_SERVICE_URL,
});

// Refresh goes to core-service, not reports-service.
attachAuthInterceptor(reportsApi, { refreshBaseUrl: CONFIG.EMPLOYEE_SERVICE_URL });

export default reportsApi;
